import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import classes from './CardIconD.module.scss';

const CardIconD = (props) => {
  const {
    heading,
    icon,
    link,
    contentMarkup,
  } = props;

  let iconHtml = '';
  let headingHtml = '';

  if (icon) {
    if (link && link.href) {
      iconHtml = (
        <a
          aria-label={heading}
          href={link.href}
          target={link.target}
        >
          <FontIcon icon={icon} className={classes.icon} />
        </a>
      );
    } else {
      iconHtml = (<FontIcon icon={icon} className={classes.iconNoLink} />);
    }
  }

  if (heading) {
    if (link && link.href) {
      headingHtml = (
        <h3 className={classes.heading}>
          <a
            aria-label={heading}
            href={link.href}
            target={link.target}
            dangerouslySetInnerHTML={{ __html: heading }}
          />
        </h3>
      );
    } else {
      headingHtml = (
        <h3
          className={classes.headingNoLink}
          dangerouslySetInnerHTML={{ __html: heading }}
        />
      );
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.iconContainer}>
        {iconHtml}
      </div>
      <div className={classes.contentContainer}>
        {headingHtml}
        {contentMarkup &&
          <div
            className={classes.contentMarkup}
            dangerouslySetInnerHTML={{ __html: contentMarkup }}
          />}
      </div>
    </div>
  );
};

CardIconD.propTypes = {
  /**
   * Heading of the card
  */
  heading: PropTypes.string,
  /**
   * Icon of the card
  */
  icon: PropTypes.string,
  /**
   * Link where you get redirected when clicking on the card
  */
  link: PropTypes.shape({
    target: PropTypes.string,
    title: PropTypes.string,
    href: PropTypes.string,
  }),
  /**
   * HTML content of the card
  */
  contentMarkup: PropTypes.string,
};

export default CardIconD;
